import api from "@/config/axios";
import CryptoJS from "crypto-js";
import store from "@/store";
import router from "@/router";
import { socketDisconnect } from "@/config/socket";

const path = "auth/";

export default {
  login(data) {
    return api.post(path + "login", data);
  },
  bitsUsuario() {
    return api.get(path + "userBits");
  },
  userInfo() {
    return api.get(path + "userInfo");
  },
  obtener_referencias() {
    return api.get(path + "userReferences");
  },
  obtener_contadores() {
    return api.get(path + "userCounter");
  },
  cambiarClave(form) {
    return api.put(path + "changePassword", form);
  },

  cambiarClaveCodigo(form) {
    return api.put(path + "changePasswordCode", form);
  },

  recuperarClave(form) {
    return api.post(path + "recoverPassword", form);
  },

  async setUserLogged(userLogged) {
    const tokenExp = userLogged.tokenExp * 1000;
    const expireTime = new Date().getTime() + tokenExp;
    userLogged.expires = expireTime;
    sessionStorage.setItem("userImage", userLogged.imagen_b64);
    delete userLogged.imagen_b64;

    const usuarioEncriptado = CryptoJS.AES.encrypt(
      JSON.stringify(userLogged),
      process.env.VUE_APP_CRYPT_KEY
    ).toString();
    sessionStorage.setItem("userLoggedTicket", usuarioEncriptado);
  },
  subirImagenPerfil(form) {
    return api.put(path + "updateProfilePicture", form);
  },

  setUserImage(imagen) {
    sessionStorage.setItem("userImage", imagen);
  },

  getUserLogged() {
    let usuarioEncriptado = sessionStorage.getItem("userLoggedTicket");
    let bytes = CryptoJS.AES.decrypt(
      usuarioEncriptado,
      process.env.VUE_APP_CRYPT_KEY
    );
    let usuario = bytes.toString(CryptoJS.enc.Utf8);

    return JSON.parse(usuario);
  },
  getUserImage() {
    return sessionStorage.getItem("userImage");
  },
  async cerrarSesion(manual = true) {
    sessionStorage.removeItem("userImage");
    sessionStorage.removeItem("userLoggedTicket");
    if (manual) await router.push("/");
    store.dispatch("limpiarSesionData", manual);
    socketDisconnect();
  },
  isAuthenticated() {
    return sessionStorage.getItem("userLoggedTicket") !== null;
  },
};
